module.exports = __webpack_public_path__ + "assets/img/icon1.40378ad9.svg";